module.exports = __webpack_public_path__ + "static/media/65.f06210ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/activity22/65.png
// module id = 204
// module chunks = 0